import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { ListItem } from "@/components/common/ListItem";
import { ChatRoomAvatar } from "@/features/chat/components/ChatRoomAvatar";
import { cn } from "@/lib/utils";

export interface ChatRoomListItem {
  id: number;
  title: string;
  displayTitle?: string;
  imageUrl?: string;
  lastEntryContent?: string;
  sublabel?: ReactNode;
  sublabelRightContent?: ReactNode;
  hidden?: boolean;
}

interface ChatRoomListSectionProps {
  title?: string;
  rooms: ChatRoomListItem[];
  onRoomClick: (roomId: number) => void;
  className?: string;
  titleClassName?: string;
  listClassName?: string;
}

export const ChatRoomListSection: React.FC<ChatRoomListSectionProps> = ({
  title,
  rooms,
  onRoomClick,
  className,
  titleClassName,
  listClassName,
}) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      {title ? (
        <h3 className={cn("mb-2 font-medium", titleClassName)}>{title}</h3>
      ) : null}
      <div className={cn("space-y-1", listClassName)}>
        {rooms.map((room) => (
          <ListItem
            key={`room-${room.id}`}
            icon={
              <ChatRoomAvatar
                title={room.title}
                displayTitle={room.displayTitle}
                imageUrl={room.imageUrl}
                size={32}
              />
            }
            label={room.displayTitle ?? room.title}
            sublabel={room.sublabel ?? room.lastEntryContent ?? ""}
            sublabelRightContent={room.sublabelRightContent}
            rightContent={
              room.hidden ? (
                <span className="rounded-full border border-border px-1.5 py-0.5 text-[10px] text-muted-foreground">
                  {t("chat.hiddenBadge")}
                </span>
              ) : null
            }
            onClick={() => onRoomClick(room.id)}
          />
        ))}
      </div>
    </div>
  );
};
